import React from 'react';
import { usePrevious } from '../../../customHooks';
import {
  IconWrapper,
  Number,
  InnerNumber,
  DollarSign,
  NumberContainer,
  BlinkAnimatedNumber,
} from './AlertCircleIcon.styles';

const AlertCircleIcon = ({ color, count, isUpsellTicket }) => {
  const prevCount = usePrevious(count);

  const countIsEven = count % 2 === 0;

  // TODO: Fix so that `prevCount` slides down and changes to `count`.
  // The duplication below was originally intended to force the old number to scroll down by remounting the icon.
  return (
    <IconWrapper>
      <InnerNumber $color={color} key={countIsEven ? 'icon_even' : 'icon_odd'}>
        <NumberContainer>
          {isUpsellTicket && <DollarSign>$</DollarSign>}
          {isUpsellTicket ? <BlinkAnimatedNumber>{count}</BlinkAnimatedNumber> : <Number>{count}</Number>}
          {isUpsellTicket ? <BlinkAnimatedNumber>{prevCount}</BlinkAnimatedNumber> : <Number>{prevCount}</Number>}
        </NumberContainer>
      </InnerNumber>
    </IconWrapper>
  );
};

export default AlertCircleIcon;
